/* ADEX — Build Your Kit (bundle builder)
 * Owns: sections/adex-kit-builder.liquid
 * No dependencies. Catalog is injected server-side by the section.
 *
 * SELECTION MODEL — changed 2026-09-04.
 * state.sel[chassisKey][categoryKey] used to hold a single product id, which
 * meant picking a second front lip silently replaced the first. Customers
 * bundling two styles from one category could not do it at all. It now holds
 * an ARRAY of product ids per category, so any number of parts from the same
 * category can go into one kit. loadState() migrates the old single-id shape
 * so a build already in sessionStorage is not lost.
 *
 * Not supported on purpose: the same product twice with different variants.
 * The cart payload sends quantity 1 per selected product, and the variant
 * chooser is keyed by product id (state.opt[productId]), so one product
 * resolves to exactly one variant. Two DIFFERENT products from one category
 * is the case that was asked for and the case that is handled.
 */
(function () {
  'use strict';

  var STORE_KEY = 'adex:kit:v1';

  function init(root) {
    if (root.dataset.kbReady === '1') return;
    root.dataset.kbReady = '1';

    var scope = root.parentNode || document;
    var dataEl = scope.querySelector('script[data-adex-kit-catalog]') ||
                 document.querySelector('script[data-adex-kit-catalog]');
    if (!dataEl) return;

    var catalog;
    try { catalog = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!catalog || !catalog.chassis || !catalog.chassis.length) return;
    window.adexKitCatalog = catalog;

    var LOCKED = !!(catalog.locked && catalog.lockKey);
    var LOCK_KEY = LOCKED ? catalog.lockKey : null;
    var CUR = catalog.currency || 'USD';
    var TIERS = (catalog.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
    var MAX_TIER = TIERS.length ? TIERS[TIERS.length - 1] : { min: 5, pct: 0 };

    var fmt = null;
    try {
      fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR, minimumFractionDigits: 2 });
    } catch (e) { fmt = null; }

    function money(cents) {
      var v = (cents || 0) / 100;
      if (fmt) return fmt.format(v);
      return '$' + v.toFixed(2);
    }

    function pad2(n) { return n < 10 ? '0' + n : '' + n; }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* Strips a leading "Adex " from a product title. Written without a regex
       escape so this file stays free of backslashes and can be round-tripped
       through the theme API as a GraphQL block string. */
    function cleanTitle(t) {
      var s = String(t == null ? '' : t).replace(/^ +/, '');
      if (s.slice(0, 5).toLowerCase() === 'adex ') return s.slice(5).replace(/^ +/, '');
      return s;
    }

    var el = {
      chassis: root.querySelector('[data-kb-chassis]'),
      chassisNote: root.querySelector('[data-kb-chassis-note]'),
      tiers: root.querySelector('[data-kb-tiers]'),
      cats: root.querySelector('[data-kb-cats]'),
      empty: root.querySelector('[data-kb-empty]'),
      summary: root.querySelector('[data-kb-summary]'),
      list: root.querySelector('[data-kb-list]'),
      placeholder: root.querySelector('[data-kb-placeholder]'),
      count: root.querySelector('[data-kb-count]'),
      miniCount: root.querySelector('[data-kb-mini-count]'),
      miniTotal: root.querySelector('[data-kb-mini-total]'),
      bar: root.querySelector('[data-kb-bar]'),
      hint: root.querySelector('[data-kb-hint]'),
      subtotal: root.querySelector('[data-kb-subtotal]'),
      discRow: root.querySelector('[data-kb-disc-row]'),
      discPct: root.querySelector('[data-kb-disc-pct]'),
      discount: root.querySelector('[data-kb-discount]'),
      total: root.querySelector('[data-kb-total]'),
      cta: root.querySelector('[data-kb-add]'),
      ctas: root.querySelectorAll('[data-kb-add]'),
      error: root.querySelector('[data-kb-error]'),
      sheetToggle: root.querySelector('[data-kb-sheet-toggle]')
    };

    var state = { chassis: null, sel: {}, opt: {}, open: {} };

    function isArr(v) {
      return Object.prototype.toString.call(v) === '[object Array]';
    }

    /* Accepts both the current shape (catKey -> [pid, pid]) and the pre-2026-09-04
       shape (catKey -> pid) so an in-progress build survives the upgrade. */
    function normalizeSel(sel) {
      if (!sel || typeof sel !== 'object') return {};
      var chKey, cKey, byCat, v;
      for (chKey in sel) {
        if (!Object.prototype.hasOwnProperty.call(sel, chKey)) continue;
        byCat = sel[chKey];
        if (!byCat || typeof byCat !== 'object') { sel[chKey] = {}; continue; }
        for (cKey in byCat) {
          if (!Object.prototype.hasOwnProperty.call(byCat, cKey)) continue;
          v = byCat[cKey];
          if (typeof v === 'number') { byCat[cKey] = [v]; }
          else if (!isArr(v)) { delete byCat[cKey]; }
        }
      }
      return sel;
    }

    function loadState() {
      try {
        var raw = sessionStorage.getItem(STORE_KEY);
        if (!raw) return;
        var s = JSON.parse(raw);
        if (s && typeof s === 'object') {
          state.chassis = s.chassis || null;
          state.sel = normalizeSel(s.sel || {});
          state.opt = s.opt || {};
        }
      } catch (e) { /* storage unavailable */ }
    }

    function saveState() {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({
          chassis: state.chassis, sel: state.sel, opt: state.opt
        }));
      } catch (e) { /* storage unavailable */ }
    }

    function currentChassis() {
      for (var i = 0; i < catalog.chassis.length; i++) {
        if (catalog.chassis[i].key === state.chassis) return catalog.chassis[i];
      }
      return null;
    }

    function selForChassis() {
      if (!state.chassis) return {};
      if (!state.sel[state.chassis]) state.sel[state.chassis] = {};
      return state.sel[state.chassis];
    }

    /* Always an array, never undefined — every caller can iterate it directly. */
    function pidsFor(catKey) {
      var arr = selForChassis()[catKey];
      return isArr(arr) ? arr : [];
    }

    function setPids(catKey, arr) {
      var sel = selForChassis();
      if (arr && arr.length) { sel[catKey] = arr; } else { delete sel[catKey]; }
    }

    function findProduct(ch, pid) {
      for (var i = 0; i < ch.categories.length; i++) {
        var ps = ch.categories[i].products;
        for (var j = 0; j < ps.length; j++) {
          if (ps[j].id === pid) return { product: ps[j], cat: ch.categories[i] };
        }
      }
      return null;
    }

    function variantFor(p) {
      var want = state.opt[p.id];
      var first = null;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v.id === want) return v;
        if (first === null && v.available) first = v;
      }
      return first || p.variants[0] || null;
    }

    function productAvailable(p) {
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return true; }
      return false;
    }

    /* Flat list of every selected part, in category order and then in the order
       the customer picked them within a category. */
    function selection() {
      var ch = currentChassis();
      if (!ch) return [];
      var out = [];
      for (var i = 0; i < ch.categories.length; i++) {
        var c = ch.categories[i];
        var pids = pidsFor(c.key);
        for (var k = 0; k < pids.length; k++) {
          var hit = findProduct(ch, pids[k]);
          if (!hit) continue;
          var v = variantFor(hit.product);
          if (!v) continue;
          out.push({ cat: c, product: hit.product, variant: v });
        }
      }
      return out;
    }

    function tierFor(n) {
      var pct = 0;
      for (var i = 0; i < TIERS.length; i++) { if (n >= TIERS[i].min) pct = TIERS[i].pct; }
      return pct;
    }

    function nextTier(n) {
      for (var i = 0; i < TIERS.length; i++) { if (n < TIERS[i].min) return TIERS[i]; }
      return null;
    }

    function renderChassis() {
      if (!el.chassis) return;
      var html = '';
      for (var i = 0; i < catalog.chassis.length; i++) {
        var c = catalog.chassis[i];
        html += '<button class="kb-chip" type="button" data-kb-chassis-btn="' + esc(c.key) +
          '" aria-pressed="' + (c.key === state.chassis ? 'true' : 'false') + '">' +
          '<strong>' + esc(c.title) + '</strong><span>' + esc(c.sub) + '</span></button>';
      }
      el.chassis.innerHTML = html;
    }

    function renderTiers(count, subtotal) {
      var html = '';
      for (var i = 0; i < TIERS.length; i++) {
        var t = TIERS[i];
        var isLast = i === TIERS.length - 1;
        var qty = isLast ? (t.min + '+ items') : (t.min + ' items');
        var active = count >= t.min && (isLast || count < TIERS[i + 1].min);
        var saved = (active && subtotal) ? (money(Math.round(subtotal * t.pct / 100)) + ' saved') : '';
        html += '<div class="kb-tier" data-active="' + (active ? 'true' : 'false') + '">' +
          (isLast ? '<span class="kb-tier__flag">Best Value</span>' : '') +
          '<div class="kb-tier__pct">' + t.pct + '%</div>' +
          '<div class="kb-tier__qty">' + esc(qty) + '</div>' +
          '<div class="kb-tier__save">' + esc(saved) + '</div>' +
          '</div>';
      }
      el.tiers.innerHTML = html;
    }

    function cardHtml(cat, p, selected) {
      var v = variantFor(p);
      var avail = productAvailable(p);
      var price = v ? v.price : p.price;
      var compare = v ? v.compare : p.compare;

      var img = p.img
        ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="640" height="480">'
        : '';

      var opts = '';
      if (p.multi && p.variants.length > 1) {
        opts = '<div class="kb-card__opts">' +
          (p.optName ? '<span class="kb-card__optlabel">' + esc(p.optName) + '</span>' : '');
        for (var k = 0; k < p.variants.length; k++) {
          var pv = p.variants[k];
          opts += '<button class="kb-card__opt" type="button" data-kb-opt="' + pv.id + '"' +
            (pv.available ? '' : ' disabled') +
            ' aria-pressed="' + (v && pv.id === v.id ? 'true' : 'false') + '">' + esc(pv.title) + '</button>';
        }
        opts += '</div>';
      }

      return '<article class="kb-card" data-kb-card data-cat="' + esc(cat.key) + '" data-pid="' + p.id + '"' +
        ' data-selected="' + (selected ? 'true' : 'false') + '" data-soldout="' + (avail ? 'false' : 'true') + '">' +
        '<button class="kb-card__btn" type="button" data-kb-toggle aria-pressed="' + (selected ? 'true' : 'false') + '"' +
        (avail ? '' : ' disabled') + '>' +
        '<span class="kb-card__media">' + img + '<span class="kb-card__check" aria-hidden="true">&#10003;</span></span>' +
        '<span class="kb-card__info">' +
        '<span class="kb-card__fit">' + esc(p.fit) + '</span>' +
        '<span class="kb-card__title">' + esc(cleanTitle(p.title)) + '</span>' +
        '<span class="kb-card__price">' + money(price) +
        ((compare && compare > price) ? '<span class="kb-card__was">' + money(compare) + '</span>' : '') +
        '</span></span></button>' +
        opts +
        '<a class="kb-card__link" href="' + esc(p.url) + '" target="_blank" rel="noopener">View details &rarr;</a>' +
        '</article>';
    }

    function renderCats() {
      var ch = currentChassis();
      if (!ch) {
        el.cats.innerHTML = '';
        el.empty.hidden = false;
        return;
      }
      el.empty.hidden = true;
      var html = '';

      for (var i = 0; i < ch.categories.length; i++) {
        var c = ch.categories[i];
        var open = state.open[ch.key + '|' + c.key];
        if (open === undefined) open = (i === 0);
        var chosen = pidsFor(c.key);
        var n = c.products.length;

        html += '<div class="kb-cat" data-open="' + (open ? 'true' : 'false') + '" data-kb-cat="' + esc(c.key) + '">' +
          '<button class="kb-cat__head" type="button" data-kb-cat-toggle aria-expanded="' + (open ? 'true' : 'false') + '">' +
          '<span class="kb-cat__num">' + pad2(i + 1) + '</span>' +
          '<span class="kb-cat__name">' + esc(c.name) + '</span>' +
          '<span class="kb-cat__meta">' + n + ' style' + (n === 1 ? '' : 's') + ' available' +
          '<span class="kb-cat__pill"' + (chosen.length ? '' : ' hidden') + '>' + chosen.length + ' selected</span>' +
          '</span>' +
          '<span class="kb-cat__chev" aria-hidden="true"></span>' +
          '</button>' +
          '<div class="kb-cat__panel"><div class="kb-grid">';

        for (var j = 0; j < c.products.length; j++) {
          var p = c.products[j];
          html += cardHtml(c, p, chosen.indexOf(p.id) > -1);
        }
        html += '</div></div></div>';
      }
      el.cats.innerHTML = html;
    }

    function renderSummary() {
      var items = selection();
      var count = items.length;
      var subtotal = 0;
      var i;
      for (i = 0; i < items.length; i++) subtotal += items[i].variant.price;

      var pct = tierFor(count);
      var discount = Math.round(subtotal * pct / 100);
      var total = subtotal - discount;

      var html = '';
      for (i = 0; i < items.length; i++) {
        var it = items[i];
        html += '<li class="kb-item">' +
          (it.product.img
            ? '<img class="kb-item__img" src="' + esc(it.product.img) + '" alt="" loading="lazy" width="46" height="40">'
            : '<span class="kb-item__img"></span>') +
          '<span class="kb-item__txt">' +
          '<span class="kb-item__name">' + esc(cleanTitle(it.product.title)) + '</span>' +
          (it.product.multi ? '<span class="kb-item__var">' + esc(it.variant.title) + '</span>' : '') +
          '<span class="kb-item__price">' + money(it.variant.price) + '</span>' +
          '</span>' +
          '<button class="kb-item__rm" type="button" data-kb-remove="' + esc(it.cat.key) +
          '" data-kb-remove-pid="' + it.product.id +
          '" aria-label="Remove ' + esc(it.product.title) + '">&times;</button>' +
          '</li>';
      }
      el.list.innerHTML = html;
      el.list.hidden = count === 0;
      el.placeholder.hidden = count > 0;

      var label = count + ' part' + (count === 1 ? '' : 's');
      el.count.textContent = label;
      el.miniCount.textContent = label;
      el.miniTotal.textContent = count ? money(total) : '—';

      el.subtotal.textContent = count ? money(subtotal) : '—';
      el.total.textContent = count ? money(total) : '—';
      el.discRow.hidden = pct === 0;
      el.discPct.textContent = pct ? ('(' + pct + '%)') : '';
      el.discount.textContent = '-' + money(discount);

      var nt = nextTier(count);
      var target = nt ? nt.min : MAX_TIER.min;
      var progress = Math.min(100, Math.round((count / target) * 100));
      el.bar.style.width = progress + '%';

      if (count === 0) {
        var t0 = TIERS.length ? TIERS[0] : { min: 2, pct: 5 };
        el.hint.textContent = 'Add ' + t0.min + ' parts to unlock ' + t0.pct + '% off.';
      } else if (nt) {
        var need = nt.min - count;
        el.hint.textContent = 'Add ' + need + ' more part' + (need === 1 ? '' : 's') + ' for ' + nt.pct + '% off.';
      } else {
        el.hint.textContent = 'Max tier unlocked — ' + pct + '% off your build.';
      }

      for (i = 0; i < el.ctas.length; i++) {
        var c = el.ctas[i];
        c.disabled = count === 0;
        if (c.hasAttribute('data-kb-add-short')) {
          c.textContent = 'Add Kit';
        } else {
          c.textContent = count === 0 ? 'Add Kit To Cart' : 'Add Kit To Cart · ' + money(total);
        }
      }

      renderTiers(count, subtotal);
      applyInview();
    }

    function renderAll() {
      renderChassis();
      renderCats();
      renderSummary();
      if (el.chassisNote) el.chassisNote.hidden = !!state.chassis;
    }

    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;

      var chip = t.closest('[data-kb-chassis-btn]');
      if (chip) {
        var key = chip.getAttribute('data-kb-chassis-btn');
        state.chassis = (state.chassis === key) ? null : key;
        saveState();
        renderAll();
        if (state.chassis && el.cats) {
          var top = el.cats.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
        return;
      }

      var catBtn = t.closest('[data-kb-cat-toggle]');
      if (catBtn) {
        var catEl = catBtn.closest('[data-kb-cat]');
        var ch = currentChassis();
        var isOpen = catEl.getAttribute('data-open') !== 'true';
        catEl.setAttribute('data-open', isOpen ? 'true' : 'false');
        catBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (ch) state.open[ch.key + '|' + catEl.getAttribute('data-kb-cat')] = isOpen;
        return;
      }

      var opt = t.closest('[data-kb-opt]');
      if (opt) {
        ev.preventDefault();
        var oCard = opt.closest('[data-kb-card]');
        var oPid = parseInt(oCard.getAttribute('data-pid'), 10);
        state.opt[oPid] = parseInt(opt.getAttribute('data-kb-opt'), 10);
        saveState();
        renderCats();
        renderSummary();
        return;
      }

      /* Additive toggle: a second pick in the same category joins the first
         rather than replacing it. */
      var toggle = t.closest('[data-kb-toggle]');
      if (toggle) {
        var tCard = toggle.closest('[data-kb-card]');
        var catKey = tCard.getAttribute('data-cat');
        var tPid = parseInt(tCard.getAttribute('data-pid'), 10);
        var arr = pidsFor(catKey).slice();
        var at = arr.indexOf(tPid);
        if (at > -1) { arr.splice(at, 1); } else { arr.push(tPid); }
        setPids(catKey, arr);
        saveState();
        renderCats();
        renderSummary();
        return;
      }

      var rm = t.closest('[data-kb-remove]');
      if (rm) {
        var rKey = rm.getAttribute('data-kb-remove');
        var rPid = parseInt(rm.getAttribute('data-kb-remove-pid'), 10);
        var rArr = pidsFor(rKey).slice();
        var rAt = rArr.indexOf(rPid);
        if (rAt > -1) rArr.splice(rAt, 1);
        setPids(rKey, rArr);
        saveState();
        renderCats();
        renderSummary();
        return;
      }

      var sheet = t.closest('[data-kb-sheet-toggle]');
      if (sheet) {
        var sOpen = el.summary.getAttribute('data-open') === 'true';
        el.summary.setAttribute('data-open', sOpen ? 'false' : 'true');
        sheet.setAttribute('aria-expanded', sOpen ? 'false' : 'true');
        return;
      }

      var add = t.closest('[data-kb-add]');
      if (add) { addToCart(add); }
    });

    var lastInView = true;

    function applyInview() {
      if (!LOCKED) return;
      // Release the bar once the builder scrolls away - but never while the
      // customer has parts selected, or we remove their only checkout
      // affordance mid-purchase.
      var keep = lastInView || selection().length > 0;
      root.setAttribute('data-kb-inview', keep ? 'true' : 'false');
      if (!keep && el.summary) {
        el.summary.setAttribute('data-open', 'false');
        if (el.sheetToggle) el.sheetToggle.setAttribute('aria-expanded', 'false');
      }
    }

    function observeViewport() {
      if (!LOCKED || typeof window.IntersectionObserver !== 'function') return;
      var io = new window.IntersectionObserver(function (entries) {
        lastInView = entries[entries.length - 1].isIntersecting;
        applyInview();
      }, { threshold: 0 });
      io.observe(root);
    }

    function cartRoot() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (r.charAt(r.length - 1) !== '/') r += '/';
      return r;
    }

    function showError(msg) {
      el.error.textContent = msg;
      el.error.hidden = false;
    }

    function addToCart(btn) {
      var items = selection();
      if (!items.length) return;
      el.error.hidden = true;

      var payload = { items: [] };
      for (var i = 0; i < items.length; i++) {
        payload.items.push({ id: items[i].variant.id, quantity: 1 });
      }

      var original = btn.textContent;
      for (var b = 0; b < el.ctas.length; b++) el.ctas[b].disabled = true;
      btn.textContent = 'Adding…';

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        }, function () {
          return { ok: res.ok, data: null };
        });
      }).then(function (r) {
        if (!r.ok) {
          var msg = (r.data && (r.data.description || r.data.message)) ||
            'One or more parts could not be added to the cart. Remove it from your build and try again.';
          showError(msg);
          for (var r2 = 0; r2 < el.ctas.length; r2++) el.ctas[r2].disabled = false;
          btn.textContent = original;
          return;
        }
        window.location.href = cartRoot() + 'cart';
      }).catch(function () {
        showError('Could not reach the cart. Check your connection and try again.');
        for (var r3 = 0; r3 < el.ctas.length; r3++) el.ctas[r3].disabled = false;
        btn.textContent = original;
      });
    }

    loadState();
    if (LOCKED) {
      state.chassis = LOCK_KEY;
    } else if (state.chassis && !currentChassis()) {
      state.chassis = null;
    }
    renderAll();
    observeViewport();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-adex-kit-builder]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-adex-kit-builder]') : null;
    if (r) init(r);
  });
})();